const ELLIPSIS = '\u2026';
const WHITESPACE_REGEX = /(?=\s)/;
const TRAILING_WHITESPACE_REGEX = /\s+$/;

export function clamp(element, {lineCount, ellipsis = ELLIPSIS} = {}) {

    // Read the `line-height` of `element`, and use it to compute the height of
    // `element` required to fit the given `lineCount`.
    const lineHeight = parseInt(window.getComputedStyle(element).lineHeight, 10);
    const maximumHeight = lineCount * lineHeight;

    // Exit if text does not overflow the `element`.
    if (element.scrollHeight <= maximumHeight) {
        return false;
    }

    const innerHTML = element.innerHTML;

    // Split the text of `element` by whitespace.
    const chunks = innerHTML.split(WHITESPACE_REGEX);

    // The text does not contain whitespace; we need to attempt to truncate
    // by character.
    if (chunks.length > 1)
        truncateByWord(element, chunks, maximumHeight);

    return truncateByCharacter(element, maximumHeight, ellipsis);
}

// Truncate the text of `element` such that it does not exceed the
// `maximumHeight`. Return `true` if we need to truncate by character, else
// return `false`.
function truncateByWord(element, chunks, maximumHeight) {

    // Loop over the chunks, and try to fit more chunks into the `element`.
    const length = chunks.length;
    let i = -1;
    let newInnerHTML = '';

    while (++i < length) {
        newInnerHTML += chunks[i];
        element.innerHTML = newInnerHTML;

        // If the new height now exceeds the `maximumHeight` (where it did not
        // in the previous iteration), we know that we are at most one line
        // over the optimal text length.
        if (element.offsetHeight > maximumHeight) {
            return;
        }
    }
}

// Append `ellipsisCharacter` to `element`, trimming off trailing characters
// in `element` such that `element` will not exceed the `maximumHeight`.
function truncateByCharacter(element, maximumHeight, ellipsisCharacter) {
    const innerHTML = element.innerHTML;
    let length = innerHTML.length;

    // In each iteration, we trim off one trailing character . Also trim
    // off any trailing punctuation before appending the `ellipsisCharacter`.
    while (length > 0) {
        element.innerHTML = innerHTML.substring(0, length).replace(TRAILING_WHITESPACE_REGEX, '') + ellipsisCharacter;
        if (element.offsetHeight <= maximumHeight) {
            return true;
        }
        length--;
    }
    return false;
}



// WEBPACK FOOTER //
// ./web/js/clamp.js